export default __webpack_public_path__ + "static/media/user.ded434de.svg";